import { render, staticRenderFns } from "./SpecimenTypeList.vue?vue&type=template&id=28992cd6&"
import script from "./SpecimenTypeList.vue?vue&type=script&lang=js&"
export * from "./SpecimenTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports